import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { Observable } from 'rxjs';

import { Patient, PatientListData } from './patient.model';
import { GetItemsParams, GetPatientParams } from '../../attorney/service/attorney.model';

@Injectable({
  providedIn: 'root'
})
export class PatientService {
  constructor(private apiService: HttpService) {}

  AddPatient(data: Patient): Observable<any> {
    return this.apiService.postData<Patient>('Patitent', data);
  }

  GetPatients(param: GetPatientParams): Observable<PatientListData> {
    let params = this.apiService.Params;
    params = params.set('searchValue', param.searchValue);
    params = params.set('skip', param.skip);
    params = params.set('take', param.take);
    params = params.set('sortColumn', param.sortColumn);
    params = params.set('sortOrder', param.sortOrder);
    params = params.set('clinicId', param.clinicId || 0);
    params = params.set('isDischarged', param.isDischarged || false);
    return this.apiService.getData<PatientListData>(`Patitent`, params);
  }

  GetPatient(id: number): Observable<any> {
    return this.apiService.getData<Patient>(`Patitent/${id}`);
  }

  UpdatePatient(data: Patient): Observable<any> {
    return this.apiService.putData<Patient>(`Patitent/${data.id}`, data);
  }

  DischargePatient(id: number): Observable<any> {
    return this.apiService.patchData<Patient>(`Patitent/${id}`, {});
  }
  ReactivePatient(id: number): Observable<any> {
    return this.apiService.patchData<Patient>(`Patitent/ReActivePatient/${id}`, {});
  }
}
